/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LngStation } from '../models/lng-station';
import { LngStationGnlList } from '../models/lng-station-gnl-list';
import { LngStationList } from '../models/lng-station-list';
import { LngUser } from '../models/lng-user';
import { LngUserList } from '../models/lng-user-list';
import { retrieveStationLng } from '../fn/lng/retrieve-station-lng';
import { RetrieveStationLng$Params } from '../fn/lng/retrieve-station-lng';
import { retrieveUserLng } from '../fn/lng/retrieve-user-lng';
import { RetrieveUserLng$Params } from '../fn/lng/retrieve-user-lng';
import { searchGnlLng$Any } from '../fn/lng/search-gnl-lng-any';
import { SearchGnlLng$Any$Params } from '../fn/lng/search-gnl-lng-any';
import { searchGnlLng$Json } from '../fn/lng/search-gnl-lng-json';
import { SearchGnlLng$Json$Params } from '../fn/lng/search-gnl-lng-json';
import { searchStationsLng$Any } from '../fn/lng/search-stations-lng-any';
import { SearchStationsLng$Any$Params } from '../fn/lng/search-stations-lng-any';
import { searchStationsLng$Json } from '../fn/lng/search-stations-lng-json';
import { SearchStationsLng$Json$Params } from '../fn/lng/search-stations-lng-json';
import { searchUsersLng$Any } from '../fn/lng/search-users-lng-any';
import { SearchUsersLng$Any$Params } from '../fn/lng/search-users-lng-any';
import { searchUsersLng$Json } from '../fn/lng/search-users-lng-json';
import { SearchUsersLng$Json$Params } from '../fn/lng/search-users-lng-json';


/**
 * LNGeneration
 */
@Injectable({ providedIn: 'root' })
export class LngService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchGnlLng()` */
  static readonly SearchGnlLngPath = '/custom/lng/stations/gnl/search';

  /**
   * Search GNL stations for LNG, with pagination.
   *
   * Search GNL stations for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnlLng$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnlLng$Json$Response(params?: SearchGnlLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationGnlList>> {
    return searchGnlLng$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search GNL stations for LNG, with pagination.
   *
   * Search GNL stations for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnlLng$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnlLng$Json(params?: SearchGnlLng$Json$Params, context?: HttpContext): Observable<LngStationGnlList> {
    return this.searchGnlLng$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngStationGnlList>): LngStationGnlList => r.body)
    );
  }

  /**
   * Search GNL stations for LNG, with pagination.
   *
   * Search GNL stations for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnlLng$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnlLng$Any$Response(params?: SearchGnlLng$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationGnlList>> {
    return searchGnlLng$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search GNL stations for LNG, with pagination.
   *
   * Search GNL stations for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnlLng$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnlLng$Any(params?: SearchGnlLng$Any$Params, context?: HttpContext): Observable<LngStationGnlList> {
    return this.searchGnlLng$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngStationGnlList>): LngStationGnlList => r.body)
    );
  }

  /** Path part for operation `searchStationsLng()` */
  static readonly SearchStationsLngPath = '/custom/lng/stations/search';

  /**
   * Search stations for LNG, with pagination.
   *
   * Search stations for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsLng$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsLng$Json$Response(params?: SearchStationsLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationList>> {
    return searchStationsLng$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations for LNG, with pagination.
   *
   * Search stations for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsLng$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsLng$Json(params?: SearchStationsLng$Json$Params, context?: HttpContext): Observable<LngStationList> {
    return this.searchStationsLng$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngStationList>): LngStationList => r.body)
    );
  }

  /**
   * Search stations for LNG, with pagination.
   *
   * Search stations for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsLng$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsLng$Any$Response(params?: SearchStationsLng$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationList>> {
    return searchStationsLng$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations for LNG, with pagination.
   *
   * Search stations for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsLng$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsLng$Any(params?: SearchStationsLng$Any$Params, context?: HttpContext): Observable<LngStationList> {
    return this.searchStationsLng$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngStationList>): LngStationList => r.body)
    );
  }

  /** Path part for operation `retrieveStationLng()` */
  static readonly RetrieveStationLngPath = '/custom/lng/stations/{uid}';

  /**
   * Retrieve a station for LNG.
   *
   * Retrieve a station for LNG
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveStationLng()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveStationLng$Response(params: RetrieveStationLng$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStation>> {
    return retrieveStationLng(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a station for LNG.
   *
   * Retrieve a station for LNG
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveStationLng$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveStationLng(params: RetrieveStationLng$Params, context?: HttpContext): Observable<LngStation> {
    return this.retrieveStationLng$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngStation>): LngStation => r.body)
    );
  }

  /** Path part for operation `searchUsersLng()` */
  static readonly SearchUsersLngPath = '/custom/lng/users/search';

  /**
   * Search users for LNG, with pagination.
   *
   * Search users for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsersLng$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsersLng$Json$Response(params?: SearchUsersLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngUserList>> {
    return searchUsersLng$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search users for LNG, with pagination.
   *
   * Search users for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsersLng$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsersLng$Json(params?: SearchUsersLng$Json$Params, context?: HttpContext): Observable<LngUserList> {
    return this.searchUsersLng$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngUserList>): LngUserList => r.body)
    );
  }

  /**
   * Search users for LNG, with pagination.
   *
   * Search users for LNG, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsersLng$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsersLng$Any$Response(params?: SearchUsersLng$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<LngUserList>> {
    return searchUsersLng$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search users for LNG, with pagination.
   *
   * Search users for LNG, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsersLng$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsersLng$Any(params?: SearchUsersLng$Any$Params, context?: HttpContext): Observable<LngUserList> {
    return this.searchUsersLng$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngUserList>): LngUserList => r.body)
    );
  }

  /** Path part for operation `retrieveUserLng()` */
  static readonly RetrieveUserLngPath = '/custom/lng/users/{uid}';

  /**
   * Retrieve a user for LNG.
   *
   * Retrieve a user for LNG
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveUserLng()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveUserLng$Response(params: RetrieveUserLng$Params, context?: HttpContext): Observable<StrictHttpResponse<LngUser>> {
    return retrieveUserLng(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a user for LNG.
   *
   * Retrieve a user for LNG
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveUserLng$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveUserLng(params: RetrieveUserLng$Params, context?: HttpContext): Observable<LngUser> {
    return this.retrieveUserLng$Response(params, context).pipe(
      map((r: StrictHttpResponse<LngUser>): LngUser => r.body)
    );
  }

}
